module.exports = __webpack_public_path__ + "img/example_1_icon.65709ec7.png";